import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { ToastProvider } from "./components/ui";

const App: React.FC = () => (
  <BrowserRouter>
    {/* Outside the route table, so a message raised just before a navigation
        is not torn down by the screen change that follows it. BrowserRouter
        above never unmounts on a navigation; only the matched route does. */}
    <ToastProvider>
      <AppRoutes />
    </ToastProvider>
  </BrowserRouter>
);

export default App;
